<template>
  <div class="boxbgcolor">
    <div class="left content-left">
      <AreaTree v-on:handleTreeClick="handleTreeClick"></AreaTree>
    </div>
    <section
      class="right content-right list list-box"
      style="margin-top: 20px; margin-left: 20px"
    >
      <div
        style="display: flex; justify-content: flex-start; align-items: center"
      >
        <div class="form-group">
          <el-select
            v-model="search.gatewayId"
            clearable
            @change="onGatewayChange"
          >
            <el-option
              v-for="item in gateways"
              :key="item.gatewayId"
              :value="item.gatewayId"
              :label="item.gatewaySn"
            ></el-option>
          </el-select>
        </div>
        <div style="width: 20px"></div>
        <div>
          <el-button :disabled="!search.parkingId" @click="addOrEdit"
            >添加</el-button
          >
          <el-button :disabled="!search.parkingId" @click="batchImport"
            >导入</el-button
          >
          <el-button :disabled="!search.parkingId || exportLoading" @click="download"
            ><i v-if="exportLoading" class="el-icon-loading"></i>{{ exportLoading ? "导出中..." : "导出" }}</el-button
          >
          <!-- <el-button :disabled="!search.parkingId" @click="onTaskClick"
            >定时任务</el-button
          > -->
        </div>
        <div style="width: 20px"></div>

        <div>
          <el-button
            :style="{
              color: isSelected === 'chart' ? '#409EFF' : '#666',
              background: isSelected === 'chart' ? '#EDF5FF' : 'white',
              borderColor: isSelected === 'chart' ? '#9FCFFF' : '#ddd',
            }"
            @click="onSwitchClick('chart')"
            >图表</el-button
          >
          <el-button
            :style="{
              color: isSelected === 'list' ? '#409EFF' : '#666',
              background: isSelected === 'list' ? '#EDF5FF' : 'white',
              borderColor: isSelected === 'list' ? '#9FCFFF' : '#ddd',
            }"
            @click="onSwitchClick('list')"
            >列表</el-button
          >
        </div>
      </div>
      <Chart
        v-if="isSelected === 'chart'"
        :parkingId="search.parkingId"
        :gatewayId="search.gatewayId"
      ></Chart>
      <List
        v-if="isSelected === 'list'"
        :parkingId="search.parkingId"
        :gatewayId="search.gatewayId"
      ></List>
    </section>
    <!--添加/修改地磁-->
    <el-dialog
      ref="park"
      title="添加地磁"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :visible.sync="dialogFormVisible"
      width="430px"
      @open="openDialog"
      @close="closeDialog"
      class="dialog-lock"
    >
      <el-form
        :model="editOrAddForm"
        :rules="editOrAddFormRules"
        ref="editOrAddFormV"
      >
        <!-- <el-form-item
          label="所属车场"
          :label-width="formLabelWidth"
          prop="devNum"
        >
          <el-col :span="18">
            <el-select v-model="editOrAddForm.parkingId" @change="onParkChange">
              <el-option
                v-for="item in shareParksData"
                :key="item.parkingId"
                :value="item.parkingId"
                :label="item.parkingName"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item> -->
        <el-form-item
          label="所属网关"
          :label-width="formLabelWidth"
          prop="devNum"
        >
          <el-col :span="18">
            <el-select v-model="editOrAddForm.gatewayId">
              <el-option
                v-for="item in gateways"
                :key="item.gatewayId"
                :value="item.gatewayId"
                :label="item.gatewaySn"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item
          label="锁编号"
          :label-width="formLabelWidth"
          prop="devNum"
        >
          <el-col :span="18">
            <el-input v-model="editOrAddForm.lockSn"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item
          label="告警声音"
          :label-width="formLabelWidth"
          prop="devNum"
        >
          <el-col :span="18">
            <el-select v-model="editOrAddForm.alarm">
              <el-option
                v-for="[key, value] in Object.entries(lockAlarm)"
                :key="key"
                :value="key"
                :label="value"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item
          label="挡臂阻尼"
          :label-width="formLabelWidth"
          prop="devNum"
        >
          <el-col :span="18">
            <el-select v-model="editOrAddForm.forarmBlock">
              <el-option
                v-for="[key, value] in Object.entries(lockForarmBlock)"
                :key="key"
                :value="key"
                :label="value"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item
          label="发射功率"
          :label-width="formLabelWidth"
          prop="devNum"
        >
          <el-col :span="18">
            <el-select v-model="editOrAddForm.power">
              <el-option
                v-for="[key, value] in Object.entries(lockPower)"
                :key="key"
                :value="key"
                :label="value"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <!-- <el-form-item
            label="升锁设置"
            :label-width="formLabelWidth"
            prop="devNum"
          >
            <el-col :span="18">
              <el-select v-model="editOrAddForm.alarm">
                <el-option
                  v-for="[key, value] in Object.entries(lockTime)"
                  :key="key"
                  :value="key"
                  :label="value"
                ></el-option>
              </el-select>
            </el-col>
          </el-form-item> -->
        <!-- <el-form-item
            label="心跳时间"
            :label-width="formLabelWidth"
            prop="devNum"
          >
            <el-col :span="18">
              <el-select v-model="editOrAddForm.alarm">
                <el-option
                  v-for="[key, value] in Object.entries(lockHeartbeat)"
                  :key="key"
                  :value="key"
                  :label="value"
                ></el-option>
              </el-select>
            </el-col>
          </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addOrEditTrue">确 定</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <!--批量添加lora地磁-->
    <el-dialog
      :close-on-click-modal="false"
      title="批量添加地磁"
      :visible.sync="batchImportDialogFormVisible"
      width="500px"
      @closed="closeUpload"
    >
      <div class="downloadTemplate">
        <span class="downloadButtonText">
          <span class="tip">*</span>请先
          <span @click="bulkLoadTemplate" class="downloadButton">下载模板</span
          >，按照模板要求填入数据后，再上传文件
        </span>
      </div>
      <div class="upload">
        <el-upload
          ref="upload"
          class="upload-demo"
          action="/prod-api/park/lock/importData"
          :multiple="false"
          name="uploadFile"
          accept="MultipartFile"
          :limit="1"
          :auto-upload="false"
          :on-success="fileSuccess"
          :on-error="fileError"
        >
          <span>上传文件:</span>
          <el-button size="small" type="primary" class="uploadButton"
            >点击上传</el-button
          >
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitUpload" size="small"
          >确 定</el-button
        >
        <el-button @click="batchImportDialogFormVisible = false" size="small"
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { gatewaysByParkingId, addLock } from "@/api/url";
import AreaTree from "@/page/commons/parking/commons/areaTree.vue";
import Chart from "./chart.vue";
import List from "./list.vue";
const LOCK_ALARM = {
  1: "打开",
  0: "关闭",
};
const LOCK_FORARM_BLOCK = {
  "00": "低",
  "01": "中",
  10: "高",
  11: "最高",
};
const LOCK_POWER = {
  "00": "低",
  "01": "中",
  10: "高",
  11: "最高",
};
const LOCK_TIME = {
  "000": "不自动升",
  "001": "2分钟",
  "010": "5分钟",
  "011": "15分钟",
  100: "30分钟",
  101: "60分钟",
};
const LOCK_HEARTBEAT = {
  "000": "1分钟",
  "001": "5分钟",
  "010": "10分钟",
  "011": "30分钟",
  100: "60分钟",
  101: "2小时",
  110: "3小时",
  111: "4小时",
};
export default {
  data() {
    return {
      batchImportDialogFormVisible: false,
      exportLoading: false,
      lockAlarm: { ...LOCK_ALARM },
      lockForarmBlock: { ...LOCK_FORARM_BLOCK },
      lockPower: { ...LOCK_POWER },
      lockTime: { ...LOCK_TIME },
      lockHeartbeat: { ...LOCK_HEARTBEAT },
      isSelected: "list",
      formLabelWidth: "100px",
      dialogFormVisible: false,
      search: {
        parkingId: "",
        gatewayId: "",
      },
      gateways: [],
      editOrAddForm: {
        // parkingId: undefined,
        gatewayId: "",
        lockSn: "",
        alarm: "",
        forarmBlock: "",
        power: "",
      },

      editOrAddFormRules: {},
      formLabelWidth: "100px",
    };
  },
  components: {
    AreaTree,
    Chart,
    List,
  },
  methods: {
    handleTreeClick: async function (node) {
      this.search.gatewayId = "";
      // 如果节点类型为停车场
      if (node.type === "parking") {
        this.search.parkingId = node.id;
        await this.getGateways(this.search.parkingId);
        // this.search.gatewayId = this.gateways?.[0]?.gatewayId ?? "";
      } else {
        this.search.parkingId = "";
      }
    },
    getGateways(id) {
      return this.$get(`${gatewaysByParkingId()}/${id}`).then((data) => {
        this.gateways = data?.data ?? [];
      });
    },
    onSwitchClick(type) {
      this.isSelected = type;
    },
    onGatewayChange(value) {
      this.search.gatewayId = value;
    },
    openDialog: function () {},
    closeDialog: function () {
      this.$refs["editOrAddFormV"].resetFields();
    },
    addOrEdit(id) {
      this.dialogFormVisible = true;
      this.editOrAddForm = {
        parkingId: "",
        lockSn: "",
        alarm: "",
        forarmBlock: "",
        power: "",
      };
    },
    addOrEditTrue() {
      var _this = this;
      this.$refs["editOrAddFormV"].validate(function (valid, noStri) {
        if (valid) {
          _this.dialogFormVisible = false;
          console.log("_this.addAndEditForm=>", _this.addAndEditForm);
          if (!_this.editOrAddForm.lockId) {
            _this
              .$postRequest(addLock(), {
                parkingId: _this.search.parkingId,
                ..._this.editOrAddForm,
              })
              .then((data) => {
                if (data.status != 200)
                  return _this.$message.error(data.message);
                _this.$notify({
                  type: "success",
                  message: "添加成功！",
                  title: "成功",
                });
              });
          }
        }
      });
    },
    download() {
      if (this.exportLoading) return;
      this.exportLoading = true;
      this.$downloadFileRequest(
        "/prod-api/park/lock/export",
        {
          parkingId: this.search.parkingId,
          gatewayId: this.search.gatewayId,
        },
        "lora地锁"
      ).finally(() => {
        this.exportLoading = false;
      });
    },
    batchImport() {
      this.batchImportDialogFormVisible = true;
    },
    //批量上传
    submitUpload() {
      this.batchImportDialogFormVisible = false;

      this.$refs.upload.submit();
    },
    bulkLoadTemplate() {
      window.open("/prod-api/park/lock/importTemplate", "_self");
    },

    closeUpload() {
      this.$refs.upload.clearFiles();
    },
    fileSuccess(response, file, fileList) {
      var _this = this;
      this.search.pageNumber = 1;
      //   this.tableList(this.search.pageNumber);
      this.batchImportResultDialogFormVisible = true;
      let span = document.createElement("span");
      this.$nextTick(function () {
        _this.$refs.showBatchImportResult.innerHTML = "";
        span.innerHTML = response.data;
        _this.$refs.showBatchImportResult.appendChild(span);
      });
    },
    fileError(err, file, fileList) {
      // console.log(err)
    },
    onTaskClick(){
        this.$router.push({path:'/main/equipment/lora-lock/task'})
    }
  },
};
</script>
<style scoped>
.list.list-box {
  height: calc(100% - 150px);
}
.downloadButton {
  font-weight: bold;
  color: #278cd8;
  cursor: pointer;
}
</style>
